module.exports = __webpack_public_path__ + "img/about_img1.d7aac804.png";